import { Typography } from '@remarkable/ark-web';

import { Trans } from '@lingui/react/macro';
import { SlidersHorizontal } from '@remarkable/ark-icons';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { Button, useCookieBanner } from 'src/components';
import { LinkExternal } from 'src/components/LinkExternal';
import { RemarkableLogo } from 'src/components/RemarkableLogo';
import { SUPPORT_URL } from 'src/utils/urls/supportUrls';
import { URLS } from 'src/utils/urls/urls';

export const Footer = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setCookieBanner] = useCookieBanner();
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-cy="footer"
      className="flex w-full animate-fade-in-up justify-center bg-paper-4"
    >
      <div className="flex w-full max-w-l2xl flex-col gap-64  px-16 py-48 lm:px-32">
        <RemarkableLogo
          variant="symbol"
          color="black"
          className="float-left size-40"
        />
        <div className="flex flex-col gap-40">
          <div className="hidden lg:block">
            {/* This is the left column which will be empty or minimal to push the content to the right */}
          </div>
          <div className="flex w-full max-w-[500px] flex-col justify-between gap-40 lxl:ml-auto lxl:flex-row">
            <div className="flex flex-col gap-12">
              <Typography variant="body-lg" fontWeight="bold" as="h2">
                <Trans>News and info</Trans>
              </Typography>

              <LinkExternal
                to={URLS.RM_COM_ABOUT}
                componentLocation={ComponentLocations.FOOTER.NEWS_AND_INFO}
              >
                <Trans>Our story</Trans>
              </LinkExternal>

              <LinkExternal
                to={SUPPORT_URL.HOME}
                componentLocation={ComponentLocations.FOOTER.NEWS_AND_INFO}
              >
                <Trans>FAQ and Support</Trans>
              </LinkExternal>

              <LinkExternal
                to={URLS.RM_COM_BLOG}
                componentLocation={ComponentLocations.FOOTER.NEWS_AND_INFO}
              >
                <Trans>Blog</Trans>
              </LinkExternal>

              <LinkExternal
                to={URLS.RM_COM_CONTACT}
                componentLocation={ComponentLocations.FOOTER.NEWS_AND_INFO}
              >
                <Trans>Contact</Trans>
              </LinkExternal>
            </div>

            <div className="flex flex-col gap-12">
              <Typography variant="body-lg" fontWeight="bold" as="h2">
                <Trans>Legal</Trans>
              </Typography>

              <LinkExternal
                to={SUPPORT_URL.LEGAL_OVERVIEW}
                componentLocation={ComponentLocations.FOOTER.LEGAL}
              >
                <Trans>Legal overview</Trans>
              </LinkExternal>

              <LinkExternal
                to={SUPPORT_URL.LEGAL_OVERVIEW}
                componentLocation={ComponentLocations.FOOTER.LEGAL}
              >
                <Trans>Terms and conditions</Trans>
              </LinkExternal>

              <LinkExternal
                to={SUPPORT_URL.PRIVACY_POLICY}
                componentLocation={ComponentLocations.FOOTER.LEGAL}
              >
                <Trans>Privacy policy</Trans>
              </LinkExternal>

              <LinkExternal
                to={SUPPORT_URL.LEGAL_OVERVIEW}
                componentLocation={ComponentLocations.FOOTER.LEGAL}
              >
                <Trans>Subscription terms and conditions</Trans>
              </LinkExternal>

              <LinkExternal
                to={SUPPORT_URL.LEGAL_OVERVIEW}
                componentLocation={ComponentLocations.FOOTER.LEGAL}
              >
                <Trans>End user license agreement</Trans>
              </LinkExternal>

              <LinkExternal
                to={SUPPORT_URL.COOKIE_POLICY}
                componentLocation={ComponentLocations.FOOTER.LEGAL}
              >
                <Trans>Cookie policy</Trans>
              </LinkExternal>

              <LinkExternal
                to={URLS.RM_COM_ACCESSIBILITY_STATEMENT}
                componentLocation={ComponentLocations.FOOTER.LEGAL}
              >
                <Trans>Accessibility statement</Trans>
              </LinkExternal>
            </div>
          </div>
        </div>

        <Typography variant="responsive-body-md" className="mt-80 text-left">
          <Trans>© {currentYear} reMarkable™. All rights reserved.</Trans>
        </Typography>
      </div>

      <Button
        variant="tertiary-neutral"
        className="absolute right-0 bottom-0 flex items-center gap-8 p-16"
        data-cy="cookie-banner-settings"
        onClick={() => {
          setCookieBanner(true);
        }}
      >
        <SlidersHorizontal size={24} className="max-h-24" />
        <span className="text-14">
          <Trans>Cookie settings</Trans>
        </span>
      </Button>
    </footer>
  );
};
